<mat-form-field fxLayout="row" class="form-full-width" appearance="outline" [formGroup]="group">
    <mat-label>{{ field.label ? field.label : '' }}</mat-label>

    <input
        matInput
        [formControl]="group.get(field.name)"
        [maxlength]="255"
        [id]="field.id ? field.id : null"
        [readonly]="field.disabled"
    />

    <mat-hint *ngIf="field.hint" [innerHtml]="field.hint"> </mat-hint>

    <fui-button
        matSuffix
        *ngIf="!field?.hideClearButton && group?.get(field.name)?.value && !field.disabled && !field.is_block"
        (clickEvent)="group?.get(field.name).setValue(''); group?.get(field.name)?.markAsDirty()"
        [title]="appService.language_dictionary.system_clear"
        [disabled]="field.disabled"
        icon="close"
        type="button-icon"
        borderRadius="circle"
        color="neutral"
        height="mini"
        iconSize="16"
    >
    </fui-button>

    <button
        matSuffix
        mat-button
        #emojiPickerTrigger="matMenuTrigger"
        [matMenuTriggerFor]="emojiPickerPopup"
        [title]="appService.language_dictionary?.system_choose"
        [disabled]="field.disabled"
        type="button"
        class="button flex items-center justify-center shrink-0 overflow-hidden rounded-full h-8 w-8 !min-w-0 !p-0"
    >
        <ng-container *ngIf="hasEmoji">
            <img [src]="currentEmojiUrl" width="24" height="24" />
        </ng-container>
        <ng-container *ngIf="!hasEmoji">
            <span class="mdi mdi-emoticon-outline text-xl"></span>
        </ng-container>
    </button>
    <mat-menu #emojiPickerPopup="matMenu">
        <app-emoji-picker (emojiPicked)="emojiPicked($event)" (click)="$event.stopPropagation()"></app-emoji-picker>
    </mat-menu>
</mat-form-field>
